import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';

const About: React.FC = () => {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "Person",
    "name": "Maya Kälin",
    "jobTitle": "Diplomierte Fusspflegerin SFPV",
    "description": "Diplomierte Fusspflegerin mit SFPV-Zertifizierung, spezialisiert auf professionelle Fusspflege in Altendorf",
    "image": "https://podo-feet.ch/images/portrait.jpg",
    "worksFor": {
      "@type": "LocalBusiness",
      "name": "PODO FEET",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "Dorfplatz 6",
        "addressLocality": "Altendorf",
        "postalCode": "8852",
        "addressCountry": "CH"
      }
    },
    "memberOf": {
      "@type": "Organization",
      "name": "SFPV - Schweizerischer Fusspflege-Verband"
    }
  };

  return (
    <>
      <SEO
        title="Über Maya Kälin - Dipl. Fusspflegerin SFPV | PODO FEET Altendorf"
        description="Maya Kälin ist diplomierte Fusspflegerin SFPV mit jahrelanger Erfahrung. Professionelle Fusspflege in moderner Praxis am Dorfplatz 6 in Altendorf."
        keywords="Maya Kälin, SFPV, diplomierte Fusspflegerin, Altendorf, Qualifikation, Erfahrung, Fusspflege-Verband"
        url="https://podo-feet.ch/ueber-uns"
        structuredData={structuredData}
      />

      {/* Hero Banner */}
      <section className="relative bg-primary py-16">
        <div className="container-custom relative z-10">
          <h1 className="heading-1 text-white mb-4">Über mich</h1>
          <div className="flex items-center text-white/90">
            <Link to="/" className="hover:text-white">Startseite</Link>
            <span className="mx-2">›</span>
            <span>Über mich</span>
          </div>
        </div>
      </section>

      {/* Maya Kälin Vorstellung */}
      <section className="section bg-white">
        <div className="container-custom">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div className="relative">
              <img 
                src="/images/portrait.jpg" 
                alt="Maya Kälin - Dipl. Fusspflegerin SFPV" 
                className="w-full h-auto rounded-lg shadow-lg"
              />
              <div className="absolute -bottom-5 -left-5 p-4 bg-primary rounded-lg shadow-lg">
                <img 
                  src="/images/sfpv_badge.png" 
                  alt="SFPV Badge" 
                  className="w-24 h-auto"
                />
              </div>
            </div>
            <div>
              <h2 className="heading-2 text-primary mb-6">Maya Kälin</h2>
              <p className="text-xl font-semibold mb-4">Diplomierte Fusspflegerin SFPV</p>
              <p className="mb-4">
                Als diplomierte Fusspflegerin mit SFPV-Zertifizierung (Schweizerischer Fusspflege-Verband) 
                biete ich Ihnen qualitativ hochwertige Fusspflege auf aktuellem fachlichem Niveau.
              </p>
              
              <p className="mb-6">
                In meiner modernen Praxis am Dorfplatz 6 in Altendorf erwartet Sie eine entspannte Atmosphäre. 
                Ich nehme mir Zeit für Ihre Anliegen und achte darauf, dass Sie sich während der Behandlung wohlfühlen.
              </p>
              <div className="flex items-center space-x-4">
                <Link to="/kontakt" className="btn btn-primary">
                  Kontakt aufnehmen
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

     

          

      {/* Standort */}
      <section className="section bg-white">
        <div className="container-custom">
          <div className="text-center mb-12">
            <h2 className="heading-2 text-primary mb-4">Standort</h2>
            <p className="max-w-3xl mx-auto">
              PODO FEET befindet sich am Dorfplatz 6 in 8852 Altendorf. 
              Die zentrale Lage bietet eine ausgezeichnete Erreichbarkeit sowohl mit öffentlichen Verkehrsmitteln als auch mit dem Auto.
            </p>
          </div>

          <div className="bg-gray-200 rounded-lg overflow-hidden shadow-lg">
            <iframe 
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2709.7229672766394!2d8.81923871595271!3d47.189583821673644!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x479ab6e8e7f6ea11%3A0xf9c9d383dd319b74!2sDorfpl.%206%2C%208852%20Altendorf%2C%20Schweiz!5e0!3m2!1sde!2sde!4v1651236555842!5m2!1sde!2sde" 
              width="100%" 
              height="450" 
              style={{ border: 0 }} 
              allowFullScreen 
              loading="lazy" 
              referrerPolicy="no-referrer-when-downgrade"
              title="PODO FEET Standort"
            ></iframe>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="bg-primary py-16">
        <div className="container-custom text-center">
          <h2 className="heading-2 text-white mb-6">Bereit für gesunde Füsse?</h2>
          <p className="text-white/90 max-w-3xl mx-auto mb-8">
            Vereinbaren Sie noch heute einen Termin und tun Sie Ihren Füssen etwas Gutes. 
            Ich freue mich darauf, Sie in meiner Praxis begrüssen zu dürfen.
          </p>
          <Link to="/kontakt" className="btn bg-white text-primary hover:bg-lightGreen">
            Jetzt Termin vereinbaren
          </Link>
        </div>
      </section>
    </>
  );
};

export default About; 